// ===================================
// UTILS - Cálculo del descuento de una línea de venta
// ===================================
// Lo comparten el modal de descuento (vista previa) y su confirmación, para que ambos
// muestren y apliquen exactamente el mismo monto.

export type TipoDescuento = 'porcentaje' | 'monto';

/**
 * Monto en pesos de un descuento porcentual. Si el cálculo tiene decimales se redondea a la
 * decena (hacia abajo con 1 a 5 de unidad, hacia arriba con 6 o más); la parte decimal cuenta
 * como unidad, así que 420,75 baja a 420 y no sube a 430.
 */
export const descuentoPorcentualEnPesos = (subtotal: number, porcentaje: number): number => {
  const calculado = (subtotal * porcentaje) / 100;
  if (Number.isInteger(calculado)) return calculado;

  const unidades = calculado % 10;
  return unidades <= 5
    ? Math.floor(calculado / 10) * 10
    : Math.ceil(calculado / 10) * 10;
};

/** Un descuento en pesos solo admite enteros: el backend guarda `descuento` como entero. */
export const esMontoDescuentoValido = (monto: number): boolean =>
  Number.isInteger(monto) && monto >= 0;
